import { useState } from 'react'
import { addDays, isBefore, parseISO, startOfDay, subDays } from 'date-fns'

import { TreeNode, TypedEntryState } from 'common/components/catalog/Catalog'
import DateRange, {
  isInclusivelyAfterDay,
  SelectorDate,
} from 'common/components/dateRange'
import FormItem from 'common/components/formItem'

export type SelectedDateRange = {
  value: { startDate: string; endDate: string }
}

type Props = {
  depth: number
  items: TreeNode | string[]
  selectedPath: string[]
  typedEntryState: TypedEntryState<string>
  onValueChange: ({ value }: { value: string[] }) => void
}

const CustomerAttributesDateRangePicker = ({
  depth,
  items,
  selectedPath,
  onValueChange,
  typedEntryState,
}: Props) => {
  const {
    value: [startDate, endDate],
  } = typedEntryState[selectedPath[depth]]

  const { startDate: defaultStartDate, endDate: defaultEndDate } =
    items[selectedPath[depth]]

  return (
    <div className="pb-13 min-w-60">
      <div className="p-4 w-full">
        <FormItem label="Date range">
          <DateRange
            startDate={startDate ? parseISO(startDate) : null}
            endDate={endDate ? parseISO(endDate) : null}
            onDatesChange={({
              startDate: newStartDate,
              endDate: newEndDate,
            }) => {
              if (newStartDate && newEndDate) {
                onValueChange({
                  value: [newStartDate.toISOString(), newEndDate.toISOString()],
                })
              }
            }}
            maxDate={new Date()}
            isOutsideRange={(day) =>
              isBefore(day, subDays(parseISO(defaultStartDate), 1)) ||
              isInclusivelyAfterDay(day, addDays(parseISO(defaultEndDate), 1))
            }
            onOutsideClick={() =>
              onValueChange({
                value: [startDate, endDate],
              })
            }
          />
        </FormItem>
      </div>
    </div>
  )
}

export default CustomerAttributesDateRangePicker
